import React, { useEffect, useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { SimpleTaxDialog } from "../Dialogs/SimpleTax";

export const ToolMenu = ({ clientJson }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [showQuickTax, setShowQuickTax] = useState(false)




  return (
    <>
      <Button
        onClick={(e) => { setAnchorEl(e.currentTarget); }}
      >
        Tools
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={(e) => { setAnchorEl(null) }}
      >
        <MenuItem
          onClick={(e) => {
            setAnchorEl(null)
            setShowQuickTax(true)
          }
          }
        >
          Tax Calculator
        </MenuItem>
      </Menu>
      <SimpleTaxDialog
        clientJson={clientJson}
        show={showQuickTax}
        onClose={() => setShowQuickTax(false)}
      />
    </>
  );
};

